import { ActivatedRouteSnapshot } from '@angular/router';

import type { BlogPostResolveResult } from '@app/features/blog/resolvers/blog-post-resolve.types';

import type { SeoRouteData } from './seo.types';

/** Walks root → leaf and shallow-merges each `data.seo` object. */
export function collectSeoFromRouteSnapshot(root: ActivatedRouteSnapshot): SeoRouteData {
  let merged: SeoRouteData = {};
  let r: ActivatedRouteSnapshot | null = root;
  while (r) {
    const raw = r.data['seo'];
    if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
      merged = { ...merged, ...(raw as SeoRouteData) };
    }

    const resolved = r.data['resolvedBlogPost'] as BlogPostResolveResult | undefined;
    if (resolved?.seo) {
      merged = { ...merged, ...resolved.seo };
    }

    r = r.firstChild ?? null;
  }
  return merged;
}

/** Returns resolved blog post data from the deepest matching route snapshot. */
export function findResolvedBlogPost(
  root: ActivatedRouteSnapshot,
): Extract<BlogPostResolveResult, { kind: 'post' }> | null {
  let resolved: BlogPostResolveResult | undefined;
  let r: ActivatedRouteSnapshot | null = root;
  while (r) {
    const candidate = r.data['resolvedBlogPost'] as BlogPostResolveResult | undefined;
    if (candidate) {
      resolved = candidate;
    }
    r = r.firstChild ?? null;
  }
  return resolved?.kind === 'post' ? resolved : null;
}
